import { APPLICATION_DETAILS_NAVIGATION } from '../constants/application-details/application-details-navigation';
import { ApplicationDetailsReview } from '../components/application/ApplicationDetailsReview';
import { ApplicationDetailsDocuments } from '../components/application/ApplicationDetailsDocuments';
import { ApplicationDetailsApplicationForm } from '../components/application/ApplicationDetailsApplicationForm';

export const APPLICATION_DETAILS_BASE_URL = '/accounts/applications/:applicationId';
export const applicationDetailsRoutes = [
  {
    key: APPLICATION_DETAILS_NAVIGATION.REVIEW,
    pathname: `${APPLICATION_DETAILS_BASE_URL}/${APPLICATION_DETAILS_NAVIGATION.REVIEW}`,
    component: <ApplicationDetailsReview />,
  },
  {
    key: APPLICATION_DETAILS_NAVIGATION.REVIEW,
    pathname: APPLICATION_DETAILS_BASE_URL,
    component: <ApplicationDetailsReview />,
  },
  {
    key: APPLICATION_DETAILS_NAVIGATION.FORM,
    pathname: `${APPLICATION_DETAILS_BASE_URL}/${APPLICATION_DETAILS_NAVIGATION.FORM}`,
    component: <ApplicationDetailsApplicationForm />,
  },
  {
    key: APPLICATION_DETAILS_NAVIGATION.DOCUMENTS,
    pathname: `${APPLICATION_DETAILS_BASE_URL}/${APPLICATION_DETAILS_NAVIGATION.DOCUMENTS}`,
    component: <ApplicationDetailsDocuments />,
  },
];